import api from "./api";

const isTokenValid = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      console.warn('Token não encontrado no localStorage.');
      return false;
    }

    const response = await api.get('api/TokenValid', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 && response.data.message === "Token valido") {
      return true;
    } else {
      console.log('Token inválido ou resposta inesperada');
      return false;
    }
  } catch (error) {
    console.error('Erro ao verificar o token:', error);
    return false;
  }
};

export default isTokenValid;
